module.exports = __webpack_public_path__ + "static/media/fashion_nova_back.a7642844.png";